import { updateHeaderCounter } from "components/jiffy/masthead-cart/masthead-cart";
import logger from "common/utils/logger";

export const cartCounterPlugin = store => {
  const getTotalItems = state => {
    try {
      return state.summary.totalItems;
    } catch (error) {
      logger.error(error);
      return 0;
    }
  };
  let lastCounter = getTotalItems(store.state.cartState);

  store.subscribe((_, state) => {
    const newCounter = getTotalItems(state.cartState);

    if (lastCounter !== newCounter) {
      lastCounter = newCounter;
      updateHeaderCounter(lastCounter);
    }
  });
};

const plugins = [cartCounterPlugin];

export default plugins;
